import { render, staticRenderFns } from "./modalProductosAgotados.vue?vue&type=template&id=54a62287&scoped=true"
import script from "./modalProductosAgotados.vue?vue&type=script&lang=js"
export * from "./modalProductosAgotados.vue?vue&type=script&lang=js"
import style0 from "./modalProductosAgotados.vue?vue&type=style&index=0&id=54a62287&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a62287",
  null
  
)

export default component.exports